// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import ExpandOutlineSvg from '@rsuite/icon-font/lib/action/ExpandOutline';
var ExpandOutline = createSvgIcon({
  as: ExpandOutlineSvg,
  ariaLabel: 'expand outline',
  category: 'action',
  displayName: 'ExpandOutline'
});
export default ExpandOutline;